<script lang="ts" setup>
import { FieldContextKey } from "vee-validate";
import { FORM_ITEM_INJECTION_KEY } from "../../../constants/forms";
import { inject, provide, useId } from "#imports";

const fieldContext = inject( FieldContextKey );
const name = fieldContext?.name;

const id = useId();
provide( FORM_ITEM_INJECTION_KEY, id );
</script>

<template>
  <div
    class="form-item"
    :class="`form-item--${name}`">
    <slot />
  </div>
</template>

<style>
.form-item > *:not(:last-child) {
  margin-bottom: var( --s-2 );
}
</style>
